import React, { useEffect, useState } from "react";
import Navbar from "../Components/Navbar";
import SearchBar from "../Components/SearchBar";
import { ToastContainer, toast } from "react-toastify";

const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const Profile = () => {

  const [values, setValues] = useState(Array(months.length).fill(""));
  const [editMode, setEditMode] = useState(false);

  const handleInputChange = (index, event) => {
    const newValues = [...values];
    newValues[index] = parseFloat(event.target.value) || 0;
    setValues(newValues);
  };

  const constructData = () => {
    const data = [];
    for (let i = 0; i < months.length; i++) {
      const value = parseFloat(values[i]);
      if (!isNaN(value)) {
        data.push({
          month: months[i],
          value: value,
        });
      }
    }
    return data;
  };
  const toggleEditMode = () => {
    setEditMode((prevEditMode) => !prevEditMode);
  };

  const handleSaveData = async () => {
    const spacedSupplierId = localStorage
      .getItem("currentUser")
      .replace(/\s/g, "");
    const data = constructData();

    if (data.length === 0) {
      console.log("No data to save.");
      return;
    }

    try {
      const currentYear = new Date().getFullYear();
      const response = await fetch(process.env.REACT_APP_API_BASEURL + "/api/profile", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          supplier: spacedSupplierId,
          year: currentYear,
          month: data,
        }),
      });

      if (response.ok) {
        console.log("Data saved successfully");
      } else {
        console.error("Error saving data:", response.statusText);
      }
    } catch (error) {
      console.error("Error saving data:", error);
    }
  };
  const notify = () => {
    toast.success("🦄 Data Saved Successfully!", {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  };

  useEffect(() => {
    const fetchProfileData = async () => {
      const spacedSupplierId = localStorage
      .getItem("currentUser")
      .replace(/\s/g, "");

      try {
        const response = await fetch(
          process.env.REACT_APP_API_BASEURL + `/api/profile/${spacedSupplierId}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );

        if (response.ok) {
          const data = await response.json();
          const newValues = Array(months.length).fill("");

          for(let i = 0; i < data.length; i++) {
            // Get month index from data[i].month.trim()
            const monthIndex = months.indexOf(data[i].month.trim());
            if (monthIndex !== -1) {
              newValues[monthIndex] = data[i].vol;
            }
          }

          setValues(newValues);

          // setValues(data.map((item) => item.value));
        } else {
          console.error("Error fetching profile data:", response.statusText);
        }
      } catch (error) {
        console.error("Error fetching profile data:", error);
      }
    };

    fetchProfileData();
  }, []);

  return (
    <>
      <div className="container-login100">
        <div className="wrap-login100">
          <Navbar />
          <div className="tableft">
            <a>Profile</a>
          </div>
          <div className="" id="result-wrapper">
            <SearchBar />
            <form
              className="login100-form validate-form profile-container"
              id="frmProfile"
              method="post"
            >
              <input name="__RequestVerificationToken" type="hidden" />
              <table className="squeez-table" id="profiledetail">
                <tbody>
                  <tr className="heading">
                    <td>Month</td>
                    <td className="ral">Weighted volume</td>
                  </tr>
                  {months.map((month, index) => (
                    <tr key={month}>
                      <td className={index % 2 === 0 ? "odd" : ""}>{month}</td>
                      <td
                        className={index % 2 === 0 ? "odd ral" : "ral"}
                        id={`clickbox${index}`}
                      >
                        <input
                          className={`txtRight ${
                            editMode ? "yellowBg" : "backgroundNone"
                          }`}
                          value={values[index]}
                          onChange={(event) => handleInputChange(index, event)}
                          type="number"
                          disabled={!editMode}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="button-theme profile-theme">
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-xs-6">
                      <div className="cancelBtn" id="forecastCancel">
                        <a onClick={toggleEditMode}>
                          <i className="icon fas fa-edit" />
                          <span>EDIT</span>
                        </a>
                      </div>
                    </div>
                    <div className="col-xs-6">
                      <div className="saveBtn" id="forecastSave">
                        <a
                          onClick={() => {
                            handleSaveData();
                            notify();
                          }}
                          disabled={!editMode}
                        >
                          <i className="icon fas fa-save" />
                          <span>SAVE</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Profile;
